import { colorStrings } from "@iewcasia/Utilities/variables";
import { videoCardWidgetStyles as styles } from "@iewcasia/Widgets/VerndaleBox/VideoCardWidget";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.wrapper = {
    css: css`
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        height: 100%;
    `,
};

styles.video = {
    css: css`
        aspect-ratio: 16/9;
        background-color: ${getColor(colorStrings.commonGlobalBlack)};
        display: flex;
        align-items: center;
        justify-content: center;

        iframe {
            border: 0;
            width: 100%;
            height: 100%;
        }
    `,
};

styles.titleWrapper = {
    css: css`
        padding: 10px;
    `,
};

styles.title = {
    variant: "h5",
    forwardAs: "h3",
    weight: 400,
    css: css`
        margin: 0;
    `,
};
